import { Breakpoint, useNotifications, useRouter } from "@relode/core";
import * as React from "react";
import { Route, Switch } from "react-router";

import { JobsProvider } from "../_infra/search/jobsProvider";
import { JobSearchProvider } from "../_infra/search/jobSearchContext";
import { JobContainer } from "../details/jobContainer";
import { JobSearchDesktop } from "./jobsSearchDesktop";
import { JobSearchMobile } from "./jobsSearchMobile";

export const JobsContainer = () => (
    <JobsProvider>
        <Switch>
            <Route
                path="/jobs"
                exact
                render={() => (
                    <JobSearchProvider>
                        <Breakpoint desktop>
                            <JobSearchDesktop />
                        </Breakpoint>
                        <Breakpoint mobile>
                            <JobSearchMobile />
                        </Breakpoint>
                    </JobSearchProvider>
                )}
            />
            <Route path="/jobs/:jobId" exact component={JobContainer} />
            <Route component={JobsNotFound} />
        </Switch>
    </JobsProvider>
);

const JobsNotFound = () => {
    const { actions: notifications } = useNotifications();
    const { history } = useRouter();
    React.useEffect(() => {
        notifications.showModal(
            "warning",
            "jobs not found",
            "We could not find the job you were looking for.  Please choose one from the following list.",
            {
                callback: () => {
                    history.replace("/jobs");
                },
                autoClose: true,
                autoCloseDuration: 10000,
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
